import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { DataComparisonApiService } from 'src/services/dataComparisonApi'

// The precompute rollup the report reads is rebuilt every five minutes; an
// open report refetches on the same cadence so it tracks the data as closely
// as the pipeline allows.
const REFRESH_INTERVAL_MS = 5 * 60 * 1000

// The report, computed by the backend at read time from the saved windows.
export const useGetDataComparisonQuery = (
  campaignId?: string,
  comparisonId?: string
) =>
  useQuery({
    enabled: !!campaignId && !!comparisonId,
    queryFn: () =>
      DataComparisonApiService.getOne(
        campaignId as string,
        comparisonId as string
      ),
    queryKey: [QueryKey.GET_DATA_COMPARISON, campaignId, comparisonId],
    refetchInterval: REFRESH_INTERVAL_MS,
  })
